export default {
  CheckAdded: 'CheckAdded',
  CheckUpdated: 'CheckUpdated',
  CheckDeleted: 'CheckDeleted',
  ChecksCleared: 'ChecksCleared',
  NotificationAdded: 'NotificationAdded',
  NotificationUpdated: 'NotificationUpdated',
  NotificationDeleted: 'NotificationDeleted',
  NotificationsCleared: 'NotificationsCleared',
  BookingAdded: 'BookingAdded',
  BookingUpdated: 'BookingUpdated',
  BookingDeleted: 'BookingDeleted',
  BookingsCleared: 'BookingsCleared',
};
